import { Children } from 'react'

import './btn-list.styl'

function BtnList({ children }) {
  const arrayChildren = Children.toArray(children)

  return (
    <div className="btn-list">
      { Children.map(arrayChildren, (child) => {
        return (
          <div className="btn-list__item">
            {child}
          </div>
        )
      })}
    </div>
  )
}

export default BtnList
